import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { LoadingScreen2 } from "@qgiv/core-donor";
import "./P2PRegistrationLoadingScreen.scss";

const P2PRegistrationLoadingScreen = (props) => {
    const { active = true } = props;
    return (
        <div
            className={cx(
                "p2p-registration-loading-screen",
                active && "p2p-registration-loading-screen--active",
            )}
        >
            <div className="p2p-registration-loading-screen__content">
                <LoadingScreen2 {...props} />
            </div>
        </div>
    );
};

P2PRegistrationLoadingScreen.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default P2PRegistrationLoadingScreen;
